var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',[_vm._v("Mentions légales")]),_c('div',[_vm._v("Contacter Idylive")]),_c('div',[_vm._v("Press")]),_c('div',[_vm._v("Membres")]),_c('div',[_vm._v("CGU")]),_c('div',[_vm._v("Mode d'emploi")]),_c('div',[_vm._v("Copyright 2010-2022")])])
}]

export { render, staticRenderFns }